module.exports = __webpack_public_path__ + "static/img/cang-zhileng.0432048b.png";